// @flow

import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { mouseEnter, showMenu, hideMenu } from '../../utils/animation';

import { setCurrentPlace } from '../../redux/actionsCreators';
import { EMPTY_PLACE } from '../../redux/reducers';

import ContactButton from '../Contact/Button';

import type { PlaceType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';

import styles from './styles.scss';
import logo from '../../assets/image/logo.svg';

type Props = {
  history: Object, // eslint-disable-line flowtype/no-weak-types
  currentPlace: PlaceType,
  setContactFormShowStatus: (status: boolean) => void,
  setCurrentPlace: (currentPlace: PlaceType) => void,
};

class Header extends React.Component<Props> {
  componentDidMount = () => {
    if (this.props.history.location.pathname === '/') {
      this.removePlace();
    }
  };

  goToMainPage = () => {
    this.removePlace();

    if (this.props.history.location.pathname !== '/') {
      this.props.history.push('/');
    }
  };

  isMainPage() {
    return this.props.history.location.pathname === '/';
  }

  isBigMenu() {
    return this.props.currentPlace.name === 'Los Angeles' || this.props.currentPlace.name === '' || this.isMainPage();
  }

  removePlace = () => {
    if (this.props.currentPlace.name) {
      this.props.setCurrentPlace(EMPTY_PLACE);

      localStorage.removeItem('currentPlace');
    }
  };

  renderNavLinks = () => (
    <ul className={classnames(styles.menu, 'menu')}>
      {this.isBigMenu() && (
        <li
          data-clear
          className={classnames('menu-item', { active: this.props.history.location.pathname.includes('/studios') })}
          onClick={(): void =>
            !this.props.history.location.pathname.includes('/studios') && this.props.history.push('/studios')
          }
          onMouseEnter={mouseEnter}
        >
          <span>Studios</span>
        </li>
      )}

      <li
        data-clear
        className={classnames('menu-item', { active: this.props.history.location.pathname === '/rentals' })}
        onClick={(): void => this.props.history.push('/rentals')}
        onMouseEnter={mouseEnter}
      >
        <span>Rentals</span>
      </li>
      <li
        data-clear
        className={classnames('menu-item', { active: this.props.history.location.pathname === '/technicians' })}
        onClick={(): void => this.props.history.push('/technicians')}
        onMouseEnter={mouseEnter}
      >
        <span>Technicians</span>
      </li>
      <li
        data-clear
        className={classnames('menu-item', { active: this.props.history.location.pathname === '/about-us' })}
        onClick={(): void => this.props.history.push('/about-us')}
        onMouseEnter={mouseEnter}
      >
        <span>About Us</span>
      </li>

      {this.isBigMenu() && (
        <li
          data-clear
          className={classnames('menu-item', { active: this.props.history.location.pathname === '/cafe' })}
          onClick={(): void => this.props.history.push('/cafe')}
          onMouseEnter={mouseEnter}
        >
          <span>Cafe</span>
        </li>
      )}
    </ul>
  );

  render() {
    return (
      <React.Fragment>
        <div id="nav-content" className={styles['full-menu-wrap']}>
          <div id="nav-inner" className={styles['menu-inner']}>
            <div
              id="hideMenu"
              className={styles['menu-hide']}
              onClick={() => {
                hideMenu().play();
              }}
            />
            {this.renderNavLinks()}
          </div>
        </div>
        <div id="header" className={styles.header}>
          <div
            id="nav-toggle"
            onClick={() => {
              showMenu().play();
            }}
          >
            <div className={styles['menu-toggle']}>
              <span className={styles.line} />
              <span className={styles.line} />
            </div>
          </div>
          <img src={logo} alt="logo" onClick={this.goToMainPage} />
          <div className={styles['menu-wrap']}>{this.renderNavLinks()}</div>

          <ContactButton additionalClass={'btn-menu'} />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: DefaultStateType): { currentPlace: PlaceType } => ({
  currentPlace: state.currentPlace,
});

const mapDispatchToProps = (dispatch): Object => ({
  setCurrentPlace(currentPlace) {
    dispatch(setCurrentPlace(currentPlace));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Header),
);



// WEBPACK FOOTER //
// ./src/components/Header/index.js